import { freeUserUpgradeStep } from '../utils';

export const myRescuesNpoTour = {
  tourKey: 'my_rescues_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: null,
  },
  steps: [
    {
      title: 'tours.my-rescues-npo.welcome.title',
      content: 'tours.my-rescues-npo.welcome.content',
      placement: 'center',
    },
    freeUserUpgradeStep,
  ],
};
